import { Tooltip } from '@/components';
import { LockOutlined } from '@ant-design/icons';
import type { FC } from 'react';

type Props = {
  hint?: string;
};

export const LockIcon: FC<Props> = ({ hint }) => {
  if (!hint) {
    return <LockOutlined style={{ fontSize: 16 }} />;
  }
  return (
    <Tooltip title={hint}>
      <LockOutlined style={{ fontSize: 16 }} />
    </Tooltip>
  );
};
